import { useState, useEffect } from 'react';

export function usePopupTransition(isOpen: boolean, duration: number) {
  const [visible, setVisible] = useState(isOpen);
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setVisible(true);
      setClosing(false);
    } else if (visible) {
      setClosing(true);
      const timer = setTimeout(() => {
        setVisible(false);
        setClosing(false);
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  return { visible, closing };
}
